import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import router from './router'
import store from './store'
import Vuex from 'vuex'
import '@/icons'
import 'babel-polyfill' //兼容IE
Vue.config.productionTip = false
Vue.use(Vuex);
Vue.use(ElementUI);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
router.beforeEach((to, from, next) => {
  let token = localStorage.getItem('token')
  // console.log(to,from,next,'>>>>>>>')
  if (to.meta.requireAuth) { // 判断该路由是否需要登录权限
    if (!token) { //未登录
      next({
        path: '/WeiXinLogin'
      })
    } else {  
      next();
    }
  }else {
    next()
  }
})